export default __webpack_public_path__ + "assets/models/1c8132586d6adeb04ad9da53b775d58b.glb";